import React from 'react';

type TabType = 'overview' | 'gauges';

interface ChartTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const ChartTabs: React.FC<ChartTabsProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'overview' as TabType, label: 'Overview' },
    { id: 'gauges' as TabType, label: 'Gauges' },
  ];

  return (
    <div 
      style={{ 
        display: 'flex', 
        gap: '0.5rem', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        marginBottom: '1rem'
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          style={{
            padding: '0.75rem 1.25rem',
            position: 'relative',
            transition: 'all 0.3s',
            color: activeTab === tab.id ? '#007AFF' : 'rgba(156, 163, 175, 1)',
            fontWeight: activeTab === tab.id ? 600 : 400,
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => {
            if (activeTab !== tab.id) {
              e.currentTarget.style.color = '#ffffff';
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab.id) {
              e.currentTarget.style.color = 'rgba(156, 163, 175, 1)';
            }
          }}
        >
          {tab.label}
          {activeTab === tab.id && (
            <div 
              style={{
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '80%',
                height: '2px',
                background: 'linear-gradient(to right, #007AFF, #AF52DE)',
                borderRadius: '2px'
              }}
            />
          )}
        </button>
      ))}
    </div>
  );
};

